import React, {Component} from 'react';
require("./Mines.scss");

let pw = 21;
let ph = 21;

const MINE = -1;
const NONE = 0;

const NO_FLAG = 0;
const MINE_FLAG = 1;
const UNDEFINED_FLAG = 2;

const difficulties = {
    1: {x: 20, y: 20, mines: 25},
    2: {x: 30, y: 20, mines: 50},
    3: {x: 30, y: 30, mines: 150}
};

class Mines extends Component {
    constructor(props) {
        super(props);

        this.state = {
            end: true,
            explosion: false,
            fx: difficulties[1].x,
            fy: difficulties[1].y,
            fields: [],
            leaves: 0,
            difficult: 1,
            mines: 0
        };
    }

    componentDidMount() {
        this.newGame();
    }

    componentWillUnmount() {

    }

    newGame = () => {

        const difficult = difficulties[this.state.difficult];
        const x = difficult.x, y = difficult.y;
        let mines = difficult.mines;

        let fields = new Array(x);
        for (let i = 0; i < x; i++) {
            fields[i] = new Array(y);
            for (let j = 0; j < y; j++) {
                fields[i][j] = {visible: false, value: NONE, i, j, flag: NO_FLAG};
            }
        }

        const minesXY = [];

        while (mines > 0) {
            const i = Math.floor((Math.random() * x));
            const j = Math.floor((Math.random() * y));
            if (fields[i][j].value !== MINE) {
                minesXY.push({i, j});
                fields[i][j].value = MINE;
                mines--;
            }
        }

        minesXY.forEach(v => {
            let ki = v.i, kj = v.j;
            this.checkNeighbors(ki, kj, (o, p) => {
                if (this.isInArea(o,p,x,y) && fields[o][p].value !== MINE) {
                    fields[o][p].value++;
                }
            });
        });

        this.setState({end: false, explosion: false, fields: fields, fx: x, fy: y, mines: minesXY.length, leaves: (x * y) - minesXY.length});

    };

    isInArea = (x,y,dx,dy) => {
        const {fx, fy} = this.state;
        const kx = dx || fx;
        const ky = dy || fy;
        return x >= 0 && x < kx && y >= 0 && y < ky;
    };

    checkNeighbors = (x, y, callback) => {
        for (let k = -1; k <= 1; k++) {
            for (let l = -1; l <= 1; l++) {
                if (k === 0 && l === 0) {
                    continue;
                }
                callback(k + x, l + y);
            }
        }
    };

    handleClickField = (field) => {
        const {fields, end, leaves, explosion} = this.state;

        let explosionNew = explosion;

        if (end || field.visible) {
            return;
        }

        let leavesNew = leaves;
        switch (field.value) {
            case MINE: {
                leavesNew = 0;
                field.explode = true;
                explosionNew = true;
                break;
            }
            case NONE: {

                let checkFields = [field];

                while (checkFields.length > 0) {
                    let tmp = checkFields.shift();
                    let i = tmp.i, j = tmp.j;

                    fields[i][j].visible = true;
                    leavesNew--;

                    this.checkNeighbors(i, j, (o, p) => {
                        if (this.isInArea(o,p) && fields[o][p].value >= NONE && fields[o][p].flag === NO_FLAG && fields[o][p].visible === false) {
                            if (fields[i][j].value === NONE && !fields[o][p].visited) {
                                fields[o][p].visited = true;
                                checkFields.push(fields[o][p]);
                            }
                        }
                    });
                }

                break;
            }
            default: {
                leavesNew--;
                field.visible = true;
            }
        }

        const newEnd = leavesNew <= 0;

        if (newEnd) {
            for (let i = 0; i < fields.length; i++) {
                for (let j = 0; j < fields[i].length; j++) {
                    fields[i][j].visible = true;
                }
            }
        }

        this.setState({fields, explosion: explosionNew, leaves: leavesNew, end: newEnd});
    };

    toggleField = (e, field) => {
        const {fields} = this.state;
        e.preventDefault();
        e.stopPropagation();
        if (field.visible) {
            return;
        }

        switch (field.flag) {
            case NO_FLAG: {
                fields[field.i][field.j].flag = MINE_FLAG;
                break;
            }
            case MINE_FLAG: {
                fields[field.i][field.j].flag = UNDEFINED_FLAG;
                break;
            }
            case UNDEFINED_FLAG: {
                fields[field.i][field.j].flag = NO_FLAG;
                break;
            }
        }

        this.setState({fields});
    };

    renderField = () => {
        const {fields} = this.state;
        const values = [];

        for (let i = 0; i < fields.length; i++) {
            for (let j = 0; j < fields[i].length; j++) {
                const field = fields[i][j];
                const x = i * pw;
                const y = j * ph;
                const visible = field.visible;

                values.push(<rect key={i + "f" + j} className={visible ? 'visible' : 'field'} onContextMenu={(e)=>this.toggleField(e, field)} onClick={()=>{if (!field.flag) this.handleClickField(field)}} x={x} y={y} width={pw} height={ph} />);

                if (field.flag && !visible) {
                    values.push(<use key={i + "d" + j} className="field" onContextMenu={(e)=>this.toggleField(e, field)} href={field.flag === UNDEFINED_FLAG ? "#undefined" : "#flag"} x={x} y={y} width={pw} height={ph} />);
                }

                if (field.value === MINE && visible) {
                    if (field.explode) {
                        values.push(<use key={i + "m" + j} href="#explode" x={x} y={y} width={pw} height={ph} />);
                    } else {
                        values.push(<use key={i + "m" + j} href="#mine" x={x} y={y} width={pw} height={ph} />);
                    }
                }

                if (visible && field.value > 0) {
                    values.push(<text key={i + "t" + j}
                          fill="black"
                          className={'val-' + field.value}
                          fontFamily="Verdana"
                          style={{'userSelect': 'none'}}
                          textAnchor="middle"
                          alignmentBaseline="baseline"
                          x={x + 10}
                          y={y + 15}>{field.value}</text>);
                }
            }
        }

        return values;

    };

    handleDifficult = (difficult) => {
        this.setState({difficult}, this.newGame);
    };

    renderDefs = () => {
        return <defs>
            <linearGradient id="r1" x1="0%" y1="8%" x2="100%" y2="92%">
                <stop offset="5%" stopColor="#EEE" />
                <stop offset="95%" stopColor="#DDD" />
            </linearGradient>
            <linearGradient id="r2" x1="0%" y1="8%" x2="100%" y2="92%">
                <stop offset="5%" stopColor="#CCC" />
                <stop offset="95%" stopColor="#CCC" />
            </linearGradient>
            <g id="explode" width={pw} height={ph}>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={pw} viewBox="0 0 100 100" height={ph}>
                  <g>
                    <path d="M92.178,73.093l-4.883-1.766l-2.442-0.883c-0.813-0.295-1.631-0.579-2.459-0.822c-0.826-0.251-1.661-0.481-2.494-0.71   c-0.829-0.24-1.662-0.475-2.488-0.727l-0.739-0.223l14.626-13.185l5.769-5.198l-7.713,0.888l-18.507,2.127l2.387-21.484   l0.761-6.852l-4.955,4.793L56.374,41.3L44.949,17.351l-3.08-6.456l-1.582,6.976l-5.785,25.49L21.994,32.441l-6.438-5.619   l2.423,8.194l6.435,21.762L9.947,53.732l-7.146-1.504l4.747,5.548l3.436,4.014c1.15,1.335,2.275,2.688,3.39,4.053   c0.562,0.679,1.136,1.346,1.728,1.999c0.596,0.648,1.207,1.285,1.816,1.921l2.183,2.281c-2.886,2.4-5.778,4.791-8.641,7.222   l-1.708,1.451l1.91,0.801l9.133,3.829c3.056,1.251,6.1,2.525,9.167,3.757c-2.837-1.694-5.696-3.345-8.544-5.017l-6.645-3.828   c3.229-2.104,6.436-4.236,9.654-6.351l1.785-1.172l-1.439-1.885l-3.212-4.206c-0.534-0.701-1.069-1.403-1.618-2.092   c-0.553-0.686-1.123-1.356-1.707-2.016c-0.723-0.809-1.44-1.622-2.152-2.439l11.38,2.395l4.073,0.857l-1.18-3.99l-5.192-17.559   l9.206,8.037l3.134,2.736l0.921-4.057l5.121-22.572l9.831,20.608l1.486,3.116l2.481-2.4l10.19-9.856l-1.969,17.73l-0.344,3.096   l3.094-0.355l13.891-1.597L70.069,67.229l-3.278,2.956l4.228,1.268l4.966,1.489c0.829,0.244,1.651,0.507,2.478,0.764   c0.821,0.268,1.645,0.533,2.472,0.779c0.827,0.253,1.665,0.466,2.507,0.668l2.524,0.606l0.077,0.019l-2.465,1.354l-7.125,3.965   l-7.115,3.981l-7.096,4.025l7.581-3.011l7.562-3.052l7.554-3.072l7.534-3.109l4.727-1.951L92.178,73.093z"/>
                    <path d="M64.805,83.72L62.8,82.988l-1.852-0.676c-0.618-0.22-1.229-0.465-1.857-0.651l-1.892-0.544l-0.193-0.058l5.482-4.943   l2.307-2.078l-3.085,0.354l-6.958,0.8l0.898-8.089l0.305-2.741l-1.982,1.918l-4.755,4.599l-4.305-9.023l-1.231-2.583l-0.633,2.79   l-2.177,9.59l-4.683-4.088l-2.574-2.248l0.969,3.277l2.418,8.176l-5.406-1.138l-2.844-0.6l1.885,2.218   c0.865,1.018,1.748,2.021,2.588,3.062c0.426,0.516,0.879,1.007,1.348,1.484l0.803,0.834c-1.08,0.903-2.161,1.804-3.231,2.719   l-0.683,0.584l0.763,0.316l3.472,1.441l3.484,1.413l-3.236-1.916l-2.475-1.438c1.215-0.788,2.424-1.586,3.637-2.378l0.713-0.464   l-0.574-0.758l-1.215-1.6c-0.398-0.538-0.814-1.062-1.26-1.561c-0.239-0.267-0.473-0.539-0.708-0.809l4.161,0.875l1.629,0.344   l-0.473-1.598l-1.92-6.493l3.36,2.934l1.253,1.095l0.369-1.623l1.91-8.421l3.668,7.687l0.594,1.246l0.992-0.96l3.766-3.642   l-0.731,6.587l-0.138,1.239l1.238-0.143l5.112-0.587l-4.487,4.044l-1.312,1.183l1.691,0.507l1.884,0.566l1.878,0.585   c0.607,0.186,1.231,0.314,1.849,0.466c-1.183,0.655-2.366,1.309-3.544,1.974c-1.802,1.005-3.591,2.034-5.384,3.059   c1.921-0.756,3.845-1.505,5.756-2.281c1.917-0.765,3.826-1.544,5.733-2.328L64.805,83.72z"/>
                  </g>
                </svg>
            </g>
            <g id="mine" width={pw} height={ph}>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={pw} x="0" y="2" viewBox="0 0 60 75" height={ph}>
                    <g>
                        <path d="M58.32,28.53l-3.38-.89a3.08,3.08,0,0,0-1.25-.07,23.11,23.11,0,0,0-3.4-9.43l2.89-4.9c.67-1.13.4-1.79.06-2.14s-1-.63-2.14,0l-4.48,2.55A23.74,23.74,0,0,0,32.47,7.16L31,1.67C30.64.4,30,.13,29.49.13h0C29,.13,28.35.4,28,1.67L26.48,7.29a23.83,23.83,0,0,0-13.31,6.59L8.33,11.12c-1.14-.65-1.79-.37-2.14,0s-.61,1,.06,2.14L9.42,18.6a22.71,22.71,0,0,0-3.1,9,3.08,3.08,0,0,0-1.25.08l-3.38.89C.4,28.86.14,29.51.14,30s.27,1.14,1.54,1.48L5,32.34a4.64,4.64,0,0,0,1.17.16h.07a23.13,23.13,0,0,0,2.92,9.39L6.25,46.77c-.67,1.14-.4,1.79-.06,2.14a1.22,1.22,0,0,0,.9.37,2.55,2.55,0,0,0,1.24-.39l4.21-2.4a23.71,23.71,0,0,0,14.22,7.28L28,58.33c.34,1.27,1,1.53,1.49,1.53s1.14-.27,1.49-1.53l1.21-4.46A23.73,23.73,0,0,0,47.26,46.7l3.83,2.18a2.55,2.55,0,0,0,1.24.39,1.22,1.22,0,0,0,.9-.37c.34-.35.61-1-.06-2.14l-2.58-4.39a23,23,0,0,0,3.19-9.89h.07A4.64,4.64,0,0,0,55,32.34l3.3-.87c1.28-.33,1.54-1,1.54-1.47S59.6,28.86,58.32,28.53ZM41.89,18.66l.89-.51,7.78-4.43-2.3,3.91h0l-2.69,4.57a.5.5,0,0,1-.88.11l-2.91-2.86a.45.45,0,0,1,.11-.81Zm-15-5.33,2.58-9.51,1.22,4.5h0l1.12,4.14.23.86h0a.47.47,0,0,1-.51.67H27.42a.47.47,0,0,1-.51-.67Zm-9.37,28-5.31,3h0L8.87,46.28l5-8.48a.59.59,0,0,1,.4-.32h0a.63.63,0,0,1,.42.21l2.9,2.86h0a.45.45,0,0,1-.11.81Zm.1-21.87-2.9,2.86a.5.5,0,0,1-.88-.11l0-.08L8.86,13.72l4,2.26h0l4.71,2.68a.45.45,0,0,1,.11.81Zm14.43,27.2-2.58,9.51-1-3.56h0l-1.61-5.94a.47.47,0,0,1,.51-.67h4.14a.47.47,0,0,1,.51.67ZM29.49,33a3,3,0,1,1,3.07-3A3,3,0,0,1,29.49,33Zm18.1,11.58h0l-5.7-3.24a.45.45,0,0,1-.11-.81L43.35,39l1.35-1.32a.63.63,0,0,1,.42-.21h0a.59.59,0,0,1,.4.32l.38.65,4.61,7.84Z"/>
                    </g>
                </svg>
            </g>

            <g id="flag" width={pw} height={ph}>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={pw} height={ph} viewBox="0 0 100 100">
                    <polygon points="20,40 60,20 60,60" style={{'fill': 'red'}} />
                    <polygon points="20,80 80,80 60,60" style={{'fill': 'black'}} />
                </svg>
            </g>

            <g id="undefined" width={pw} height={ph}>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={pw} height={ph} viewBox="-50 -50 620 620">
                    <path d="M197.653 314.102c-8.673-135.209 97.628-94.188 98.212-151.378 0-24.279-21.371-33.516-42.752-33.516-27.126 0-37.581 18.473-37.581 47.954h-119.562c2.314-46.224 21.945-79.728 51.978-102.257 29.481-21.954 69.356-32.368 112.097-32.368 88.965 0 155.976 39.885 155.976 117.893 0 99.952-123.065 79.135-112.097 153.692h-106.27zM310.303 357.427v112.046h-119.010v-112.046h119.010z" strokeWidth="10" stroke="black" fill="yellow" />
                </svg>
            </g>

        </defs>
    };

    render() {
        const {end, fx, fy, difficult, mines, explosion, leaves} = this.state;

        const texts = [];

        texts.push(<span>Počet min: <strong>{mines}</strong></span>);

        if (explosion) {
            texts.push(<div><strong>Prohra, zkuste to znovu.</strong></div>);
        } else {
            if (leaves === 0 && mines > 0 && end) {
                texts.push(<div><strong>Výhra, gratulujeme!</strong></div>);
            }
        }

        return (
            <div className="mines">
                <div className="actions">
                    <button onClick={this.newGame}>Nová hra</button>
                    <input type="radio" name="level" checked={difficult === 1} onClick={()=>this.handleDifficult(1)} /> Normální
                    <input type="radio" name="level" checked={difficult === 2} onClick={()=>this.handleDifficult(2)} /> Střední
                    <input type="radio" name="level" checked={difficult === 3} onClick={()=>this.handleDifficult(3)} /> Těžké
                </div>
                <div className="game">
                    <svg className={"board" + (end ? " end" : "")} ref="board"  style={{width: fx * pw, height: fy * ph}} tabIndex="0" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        {this.renderDefs()}
                        {this.renderField()}
                    </svg>
                </div>
                <div className="score">
                    {texts}
                </div>
            </div>
        )
    }
}

export default Mines;
